import { jwtDecode } from "jwt-decode";
import store from "../redux/store";

const SESSION_TIMEOUT =  120 * 60 * 1000; // 120 minutes
let lastActivity = Date.now();
let sessionCheckInterval = null;

// Check if token is valid and not expired
export const isTokenValid = (token) => {
    if (!token) return false;
    
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000 > Date.now();
    } catch (error) {
        console.error("Invalid token:", error);
        return false;
    }
};

// Check if user is authenticated
export const isAuthenticated = () => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    
    if (!accessToken || !refreshToken) {
        return false;
    }
    
    return isTokenValid(accessToken);
};

// Check if user is fully authenticated
export const isFullyAuthenticated = () => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const user = store.getState().auth.user;
    
    if (!accessToken || !refreshToken || !user?.id) {
        return false;
    }
    
    return isTokenValid(accessToken);
};

// Check if refresh token is valid
export const isRefreshTokenValid = () => {
    const refreshToken = localStorage.getItem("refreshToken");
    return isTokenValid(refreshToken);
};

// Update last activity timestamp
export const updateLastActivity = () => {
    lastActivity = Date.now();
};

// Check for session timeout
export const checkSessionTimeout = () => {
    const isAuth = isAuthenticated();
    if (isAuth && (Date.now() - lastActivity > SESSION_TIMEOUT)) {
        return true; // Session timed out
    }
    return false;
};

// Start session monitoring
export const startSessionMonitoring = (logoutCallback) => {
    if (sessionCheckInterval) {
        clearInterval(sessionCheckInterval);
    }
    
    sessionCheckInterval = setInterval(() => {
        if (checkSessionTimeout()) {
            console.log("Session timed out due to inactivity");
            logoutCallback();
        }
    }, 60000);
    
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => {
        document.addEventListener(event, updateLastActivity);
    });
};

// Stop session monitoring
export const stopSessionMonitoring = () => {
    if (sessionCheckInterval) {
        clearInterval(sessionCheckInterval);
        sessionCheckInterval = null;
    }
    
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => {
        document.removeEventListener(event, updateLastActivity);
    });
};

// Get token expiry time
export const getTokenExpiry = (token) => {
    if (!token) return null;
    
    try {
        const decoded = jwtDecode(token);
        return new Date(decoded.exp * 1000);
    } catch {
        return null;
    }
};

// Check if token needs refresh
export const shouldRefreshToken = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return false;
    
    try {
        const decoded = jwtDecode(accessToken);
        const expiryTime = decoded.exp * 1000;
        const currentTime = Date.now();
        const timeUntilExpiry = expiryTime - currentTime;
        
        return timeUntilExpiry < 5 * 60 * 1000 && timeUntilExpiry > 0;
    } catch {
        return false;
    }
};